const BG_VISIBLE_LAZY_CLASS_NAME = "bg-visible-lazy";
const BG_LAZY_CLASS_NAME = "bg-lazy";

export { BG_LAZY_CLASS_NAME, BG_VISIBLE_LAZY_CLASS_NAME };
